import { httpClient } from '../httpClient';

export const categoryWorkflowMethods = {
  // ── Spec 020 Wave B: category workflow ─────────────────────────────────
  getCategories: (assessmentId) =>
    httpClient.get(`/pdpl/assessments/${assessmentId}/categories`),

  getCategoryQuestions: (assessmentId, categoryId, locale = 'en') =>
    httpClient.get(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/questions`,
      { params: { locale } },
    ),

  saveCategoryAnswer: (assessmentId, questionExtId, body) =>
    httpClient.patch(
      `/pdpl/assessments/${assessmentId}/answers/${questionExtId}`,
      body,
    ),

  // ── Spec 020 Wave C1: per-category approval workflow ───────────────────
  submitCategoryForApproval: (assessmentId, categoryId, body = {}) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/submit`,
      body,
    ),

  approveCategory: (assessmentId, categoryId, body) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/approve`,
      body,
    ),

  rejectCategory: (assessmentId, categoryId, body) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/reject`,
      body,
    ),

  requestCategoryChanges: (assessmentId, categoryId, body) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/request-changes`,
      body,
    ),

  recallCategory: (assessmentId, categoryId, body) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/recall`,
      body,
    ),

  reopenCategory: (assessmentId, categoryId, body) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/reopen`,
      body,
    ),

  markCategoryReviewOpened: (assessmentId, categoryId) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/categories/${categoryId}/review-opened`,
      {},
    ),

  // ── Attestation text (Wave C1 T057) ────────────────────────────────────
  getAttestationText: (categoryId, locale = 'en') =>
    httpClient.get(`/pdpl/attestation-text/${categoryId}`, { params: { locale } }),

  updateAttestationText: (categoryId, body) =>
    httpClient.patch(`/pdpl/attestation-text/${categoryId}`, body),

  // ── Activity drawer (Wave C1 T060, US8) ────────────────────────────────
  getQuestionActivity: (questionExtId, params) =>
    httpClient.get(`/pdpl/questions/${questionExtId}/activity`, { params }),

  // ── Audit log (Wave C1 T170) ───────────────────────────────────────────
  getAuditLog: (params) =>
    httpClient.get('/pdpl/audit-log', { params }),

  getApprovalEvents: (params) =>
    httpClient.get('/pdpl/approval-events', { params }),
};
